<template>
  <div class="phone-decorate">
    <second-menu-link-content>
      <template v-slot:header>
        <span>手机装修</span>
      </template>
      <template v-slot:content>
        <div class="phone-decorate-main" ref="main">
          <div class="phone-home">
            <div class="phone-header">亿店宝商城</div>
            <div class="phone-search"></div>
            <div class="banner">
              <!-- <img v-if="images.length>0" :src="images[0].img" alt /> -->
              <el-carousel trigger="click" height="160px">
                <el-carousel-item v-for="(item,index) in images" :key="index">
                  <img :src="item.img" alt />
                </el-carousel-item>
              </el-carousel>
            </div>
            <p class="future">敬请期待...</p>
          </div>
          <div class="decorate">
            <div class="editor">
              <div class="set">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9897"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    d="M1009.152 486.4l-226.304-392.192c-9.216-15.872-26.112-25.6-44.544-25.6H285.696c-18.432 0-35.328 9.728-44.544 25.6L14.848 486.4c-9.216 15.872-9.216 35.328 0 51.2l226.304 392.192c9.216 15.872 26.112 25.6 44.544 25.6h453.12c18.432 0 35.328-9.728 44.544-25.6l226.304-392.192c8.704-15.872 8.704-35.328-0.512-51.2z m-276.48 407.552H291.328l-220.16-381.952L291.84 130.048h440.832l220.672 381.952-220.672 381.952z"
                    fill="#1296db"
                    p-id="9898"
                  />
                  <path
                    d="M512 332.8c-98.816 0-179.2 80.384-179.2 179.2s80.384 179.2 179.2 179.2 179.2-80.384 179.2-179.2-80.384-179.2-179.2-179.2z m0 296.96c-65.024 0-117.76-52.736-117.76-117.76s52.736-117.76 117.76-117.76 117.76 52.736 117.76 117.76-52.736 117.76-117.76 117.76z"
                    fill="#1296db"
                    p-id="9899"
                  />
                </svg>
              </div>
              <div class="remove-up" @click="upImg">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1835"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    :fill="imgEditorIndex ===0 ||imgEditorIndex ===''?'#eeeeee':'#999999'"
                    d="M907.955934 352.01498L563.195206 7.254252a24.183503 24.183503 0 0 0-7.565833-5.089161c-0.087882-0.039946-0.167775-0.095871-0.263646-0.135818a24.071654 24.071654 0 0 0-3.890771-1.206379c-0.239678-0.055925-0.463377-0.159785-0.711045-0.207721-1.597853-0.319571-3.219674-0.487345-4.833505-0.487345H497.139968a24.279375 24.279375 0 0 0-19.669569 10.090441L135.65771 352.01498a24.367256 24.367256 0 0 0 0 34.473676l34.473676 34.481665a24.383235 24.383235 0 0 0 34.473676 0l268.151671-268.15966V999.616765a24.375246 24.375246 0 0 0 24.383235 24.383235h48.758481a24.375246 24.375246 0 0 0 24.375246-24.383235V152.243423l268.726898 268.726898a24.383235 24.383235 0 0 0 34.473676 0l34.473676-34.481665a24.367256 24.367256 0 0 0 0.007989-34.473676z"
                    p-id="1836"
                  />
                </svg>
              </div>
              <div class="remove-down" @click="downImg">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1389"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    :fill="imgEditorIndex ===images.length-1||imgEditorIndex ===''?'#eeeeee':'#999999'"
                    d="M116.044066 671.98502L460.804794 1016.745748a24.183503 24.183503 0 0 0 7.565833 5.089161c0.087882 0.039946 0.167775 0.09587099 0.263646 0.135818a24.071654 24.071654 0 0 0 3.89077101 1.206379c0.239678 0.055925 0.463377 0.159785 0.71104499 0.207721 1.597853 0.319571 3.21967399 0.487345 4.833505 0.487345L526.860032 1023.872172a24.279375 24.279375 0 0 0 19.66956899-10.090441L888.34229001 671.98502a24.367256 24.367256 0 0 0-1e-8-34.473676l-34.47367601-34.481665a24.383235 24.383235 0 0 0-34.47367599 0l-268.151671 268.15966L551.243267 24.383235a24.375246 24.375246 0 0 0-24.383235-24.383235l-48.758481 0a24.375246 24.375246 0 0 0-24.375246 24.383235L453.726305 871.756577l-268.726898-268.726898a24.383235 24.383235 0 0 0-34.47367599 0l-34.47367601 34.481665a24.367256 24.367256 0 0 0-0.007989 34.473676z"
                    p-id="1390"
                  />
                </svg>
              </div>
              <div class="remove" @click="removeImg">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2557"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    d="M519.669429 0c-104.534771 0-189.591705 82.942197-193.175627 186.875937H82.586757A49.195452 49.195452 0 0 0 33.391304 236.026869a49.195452 49.195452 0 0 0 49.195453 49.150931h54.315341v550.900024C136.902098 939.499576 207.111354 1023.97774 293.704254 1023.97774h441.690572c86.5929 0 156.802156-83.966175 156.802156-187.899916V285.689789h49.195453A49.195452 49.195452 0 0 0 990.587887 236.538858a49.195452 49.195452 0 0 0-49.195452-49.150932H712.333066A192.663638 192.663638 0 0 0 519.691689 0zM411.81786 178.083085c3.561662-50.063607 46.902633-89.041543 100.4166-89.041542C565.770687 89.041543 609.111658 128.019478 612.161331 178.083085h-200.343471z m-112.637551 756.341123c-31.16454 0-65.445534-39.356362-65.445534-95.586096V289.385013h578.770027v549.965088C812.504802 895.579835 778.223808 934.936197 747.059268 934.936197H299.180309v-0.511989z"
                    :fill="imgEditorIndex ===''?'#eeeeee':'#999999'"
                    p-id="2558"
                  />
                  <path
                    d="M367.297089 801.373883c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C411.81786 444.762505 391.783513 422.947327 367.297089 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C322.776318 779.558705 342.254155 801.373883 367.297089 801.373883z m155.8227 0c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C567.64056 444.762505 547.606213 422.947327 523.119789 422.947327s-44.520771 21.815178-44.520772 49.106411v280.213734C478.599017 779.558705 498.633364 801.373883 523.119789 801.373883z m133.562313 0c24.486424 0 44.520771-21.815178 44.520772-49.106411V472.053738C701.202874 444.762505 681.168527 422.947327 656.682102 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C612.161331 779.558705 631.639169 801.373883 656.682102 801.373883z"
                    :fill="imgEditorIndex ===''?'#eeeeee':'#999999'"
                    p-id="2559"
                  />
                </svg>
              </div>
            </div>
            <div class="img-setting">
              <div class="title">
                <span>Banner模块</span>
              </div>
              <div class="img-upload">
                <p class="img-content">
                  <span class="blue">*</span>
                  <span>图片</span>
                </p>
                <p class="explain">建议图片尺寸为750*320px，支持jpg、png格式，最多上传6张图片</p>
                <div class="upload">
                  <el-upload
                    action="#"
                    list-type="picture-card"
                    :auto-upload="true"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :limit="limit"
                    :disabled="limit === -1?true:false"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>
              <div class="auto">
                <div class="img-container">
                  <div class="img-content" v-for="(value,index) in images" :key="index">
                    <div
                      :class="imgEditorIndex === index ?'img imgEditor':'img'"
                      @click="imgEditor(index)"
                    >
                      <img :src="value.img" alt />
                    </div>
                    <div class="link">
                      <span class="text">链接：</span>
                      <el-input class="white" v-model="value.link"></el-input>
                    </div>
                  </div>
                </div>
                <div class="btn">
                  <el-button class="btn-blue" @click="saveBanner">确认</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import ImgUploader from "models/img-upload.js";
import DBMall from "models/db/mall.js";
const dbMall = new DBMall();
const imgUploader = new ImgUploader();
export default {
  components: {
    SecondMenuLinkContent
  },
  data() {
    return {
      fileList: [],
      images: [],
      imgEditorIndex: ""
    };
  },
  computed: {
    limit() {
      return 5 - this.images.length;
    }
  },
  created() {
    this.getBannerData();
  },
  mounted() {
    this.$refs["main"].style.height =
      document.querySelector(".content").offsetHeight - 40 - 32 - 32 + "px";
  },
  methods: {
    // 获取当前数据
    getBannerData() {
      dbMall.getDBBannerList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.img = value.pic;
            obj.link = value.url;
            arr.push(obj);
          });
          this.images = arr;
        }
      });
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      } else {
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.img = res.imgUrl;
              obj.link = "";
              this.images.push(obj);
              console.log(obj);
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
    // 选中图片
    imgEditor(index) {
      if (this.imgEditorIndex === index) {
        this.imgEditorIndex = "";
      } else {
        this.imgEditorIndex = index;
      }
    },
    // 上移选中的图片
    upImg() {
      if (this.imgEditorIndex === "") {
        console.log("请选择图片");
      } else {
        if (this.imgEditorIndex === 0) {
          console.log("该图片已是第一个图片");
        } else {
          let obj = this.images[this.imgEditorIndex];
          this.images.splice(this.imgEditorIndex, 1);
          this.images.splice(this.imgEditorIndex - 1, 0, obj);
          this.imgEditorIndex -= 1;
        }
      }
    },
    // 下移选中的图片
    downImg() {
      if (this.imgEditorIndex === "") {
        console.log("请选择图片");
      } else {
        if (this.imgEditorIndex === this.images.length - 1) {
          console.log("该图片已是最后一个图片");
        } else {
          let obj = this.images[this.imgEditorIndex];
          this.images.splice(this.imgEditorIndex, 1);
          this.images.splice(this.imgEditorIndex + 1, 0, obj);
          this.imgEditorIndex += 1;
        }
      }
    },
    // 删除选中的图片
    removeImg() {
      if (this.imgEditorIndex === "") {
        console.log("请选择图片");
      } else {
        this.images.splice(this.imgEditorIndex, 1);
      }
    },
    // 保存
    saveBanner() {
      let data = [];
      this.images.map(value => {
        let obj = {};
        obj.pic = value.img;
        obj.url = value.link;
        data.push(obj);
      });
      dbMall.postDBUpdateBanner(data).then(res => {
        if (res.success) {
          this.$message.success("保存成功");
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.phone-decorate {
  width: 100%;
  height: 100%;
  .phone-decorate-main {
    height: 100%;
    display: flex;
    .phone-home {
      width: 375px;
      height: 100%;
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      .phone-header {
        height: 44px;
        font-size: 16px;
        line-height: 44px;
        text-align: center;
        color: #666666;
      }
      .phone-search {
        height: 44px;
        background: url(../../../../assets/phone-decorate/search.png) center
          no-repeat;
      }
      .banner {
        height: 160px;
        background: url(../../../../assets/phone/bannerbg.png) center no-repeat;
        img {
          width: 100%;
          height: 160px;
        }
      }
      .future {
        font-size: 14px;
        padding: 15px;
        text-align: center;
      }
    }
    .decorate {
      margin-left: 16px;
      height: 100%;
      width: 398px;
      display: flex;
      justify-content: space-between;
      .editor {
        width: 32px;
        height: 145px;
        background: #fff;
        box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-evenly;
      }
      .img-setting {
        width: 350px;
        height: 100%;
        padding-bottom: 40px;
        box-sizing: border-box;
        background: #fff;
        box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        .title {
          padding: 0 16px;
          box-sizing: border-box;
          width: 100%;
          height: 44px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(238, 238, 238, 1);
        }
        .img-upload {
          width: 100%;
          box-sizing: border-box;
          padding: 0 16px;
          font-size: 14px;
          color: #999999;
          .img-content {
            padding: 8px 0;
            .blue {
              color: #3d74f2;
            }
          }
          .explain {
            font-size: 12px;
            line-height: 18px;
            margin-bottom: 12px;
          }
        }
        .auto {
          overflow: auto;
          flex: 1;
          width: 100%;
          box-sizing: border-box;
          padding: 0 16px;
          .img-container {
            width: 100%;
            min-height: 100px;
            .img-content {
              padding-top: 10px;
              padding-bottom: 10px;
              border-bottom: 1px solid #eeeeee;
              .img {
                width: 100%;
                height: 140px;
                box-sizing: border-box;
                margin-bottom: 12px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .imgEditor {
                box-sizing: border-box;
                border: 2px solid #3d74f2;
              }
              .link {
                display: flex;
                align-items: center;
                .text {
                  display: block;
                  width: 75px;
                  font-size: 14px;
                }
              }
            }
          }
          .btn {
            left: 50%;
            margin-left: -32px;
            justify-content: center;
            display: flex;
            position: absolute;
            bottom: 6px;
            .el-button {
              width: 64px;
              height: 28px;
              font-size: 12px;
            }
          }
        }
        .auto::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }
        .auto::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 7px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #ccc;
        }
        .auto::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          background: #ededed;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.phone-decorate {
  .el-carousel__indicators {
    display: none;
  }
  .upload {
    padding-bottom: 16px;
    .el-upload {
      width: 100%;
      height: 140px;
      background: rgba(246, 246, 246, 1);
      border: 0;
    }
  }
}
</style>
